import { createBulkCameraViaApi, updateProductApi } from '../../api/retailAutomationApis';
import { CRUD_RETAIL_AUTOMATION_HOTSPOT_PRESIGNED, CRUD_RETAIL_AUTOMATION_HOTSPOT_UPDATE } from '../../config/constant/apiConstant';
import { apiPatch, apiPost, apiPostImageOnPresignedData } from '../../helpers/api';
import { updateDbMaterial, updateDbTexture } from '../../helpers/idb';
import { errorToast, errorToastV2 } from '../../helpers/toastHelper';
import {
  selectArtworksJson,
  selectHotspotsJson,
} from '../../redux/slicers/retailAutomation/retailAutomation.slicer';
import { getAppState } from '../../redux/store';

const getHotspotJson = (id) => {
  if (!id) return {};
  return selectHotspotsJson(getAppState())?.[id];
};

const getArtworkJson = (id) => {
  if (!id) return {};
  return selectArtworksJson(getAppState())?.[id];
};

export const createHotspotCamera = async ({
    automationId, 
    retailSetId, 
    hotspotId, 
    cameraList,
    filterWithoutId = false,
    autoEnableFirst = false
  }) => {
    const all_camera_details = [];

    cameraList.forEach((camera, index) => {
      if (filterWithoutId && camera?.id) return;

      all_camera_details.push({
        name: camera?.name || `Camera ${index + 1}`,
        seq_no: index + 1,
        camera_data: JSON.stringify(camera.camera_data || camera),
        thumb: camera?.thumbnail || 'thumb.png',
        is_enable: autoEnableFirst ? index === 0 : true,
      });
    });

    const payload = {
      retail_automation: automationId,
      retail_set: retailSetId,
      hotspot: hotspotId,
      all_camera_details,
    };

    const response = await createBulkCameraViaApi(payload);
    return response?.data || [];
  }

export const updateHotspotProductApi = async ({ id, payload }) => {
  const response = await updateProductApi({ id, payload });
  return response
};

export const updateHotspotJsonApiV2 = async ({ data })=> {
  const formData = new FormData();
  formData.append("hotspot", data.id);
  formData.append("json_file_name", "hotspot_json.json");

  try {
    // Step 1: Get presigned upload URL
    const presignedRes = await apiPost(
      CRUD_RETAIL_AUTOMATION_HOTSPOT_PRESIGNED,
      formData,
      'apiPostHotspotPresignedData',
      null,
      null,
      true
    );

    if (!presignedRes?.status || !data?.json_file || !presignedRes?.data?.presigned_data) {
      errorToast('Unable to update the hotspot JSON.');
      throw new Error('Presigned data or JSON file missing.');
    }

    // Step 2: Upload the file to S3
    const uploadSuccess = await apiPostImageOnPresignedData(
      data.json_file,
      presignedRes.data.presigned_data
    );

    if (!uploadSuccess) {
      errorToast('Failed to upload JSON file.');
      throw new Error('Upload failed.');
    }

    // Step 3: Patch the hotspot with the uploaded file's key
    const patchPayload = { json_file_url: presignedRes.data.key };

    const patchResponse = await apiPatch(
      `${CRUD_RETAIL_AUTOMATION_HOTSPOT_UPDATE}${data.id}/`,
      patchPayload,
      'apiPatchHotspotJsonData',
      null,
      null,
      true
    );

    return patchResponse;
  } catch (error) {
    errorToastV2('Something went wrong! Please try again.');
    return null;
  }
}

export const buildTextureDataV2 = ({ textures, copiedDefaultArtwork, combination }) => {
    // removed the async logic from the this function as we don't need to wait for the material/texture to update it in the db
    let copyTex = JSON.parse(JSON.stringify(textures));
    let defaultArtwork = JSON.parse(JSON.stringify(copiedDefaultArtwork?.item));
    if (copyTex?.length) {
      for (let j = 0; j < copyTex?.length; j++) {
        if (copyTex[j].material && copyTex[j]?.material_data?.material_image) {
          updateDbMaterial(copyTex[j].material_data);
        }
        if (copyTex[j].texture && copyTex[j]?.texture_data?.texture_file) {
          updateDbTexture(copyTex[j].texture_data);
        }

        const seqNo = copyTex[j].seq_no;

        // Here, if the seq_no matched then keeping the new artwork
        // Otherwise, adding the default artwork data
        defaultArtwork = defaultArtwork?.map((a) =>
          a.seq_no === seqNo
            ? {
                ...a,
                ...copyTex[j],
                combinationId: combination?.id,
                isRender: combination?.is_render,
              }
            : {
                ...a,
                combinationId: combination?.id,
                isRender: combination?.is_render,
                defaultAdded: true,
              }
        );
      }
      copyTex = JSON.parse(JSON.stringify(defaultArtwork));
      while (copyTex?.length < copiedDefaultArtwork?.item?.length) {
        let itemCopy = JSON.parse(JSON.stringify(copiedDefaultArtwork?.item[copyTex?.length]));
        copyTex.push({
          ...itemCopy,
          combinationId: combination?.id,
          isRender: combination?.is_render,
          defaultAdded: true,
        });
      }
    } else {
      while (copyTex?.length < copiedDefaultArtwork?.item?.length) {
        copyTex.push({
          id: copyTex?.length,
          upload: true,
          combinationId: combination?.id,
          isRender: combination?.is_render,
        });
      }
    }
    for (let i = 0; i < copyTex.length; i++) {
      copyTex[i]['defaultObjData'] = copiedDefaultArtwork.item[i];
    }
    return copyTex;
  };